import React from "react";
import { ConveniosPage } from "./convenios.page";
import { ConveniosProvider } from "./context/convenios-context";

export function ConveniosFactory() {
    return (
        <ConveniosProvider>
            <ConveniosPage></ConveniosPage>
        </ConveniosProvider>
    );
}
